(function () {
  const root = document.getElementById('bls-product-v2');
  if (!root) return;

  const $  = (sel, ctx = root) => ctx.querySelector(sel);
  const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

  

// --- Thumb rail height = stage (main image) height ---
(function setupThumbRailHeightSync(){
  const stage  = root.querySelector('.bls-v2__stage-inner');
  const thumbs = root.querySelector('.bls-v2__thumbs');
  if (!stage || !thumbs) return;
function isNarrow(){ return window.matchMedia('(max-width: 767.98px)').matches; }
  function syncThumbsHeight(){
        // On phones, thumbs sit under the image (horizontal scroll) – no fixed height
    if (isNarrow()){ thumbs.style.height = ''; return; }
    const r = (root.querySelector('.bls-v2__slide.is-active .bls-v2__stage-inner') || stage).getBoundingClientRect();
    const h = Math.max(0, Math.round(r.height));
    thumbs.style.height = h + 'px';
  }

  // Recalc on resize, image load, and any gallery interaction
  window.addEventListener('resize', syncThumbsHeight);

  // Watch the stage for size changes (slides/aspect changes)
  try { new ResizeObserver(syncThumbsHeight).observe(stage); } catch(e){}

  // If your gallery swaps slides on click, recalc after clicks
  root.addEventListener('click', (e) => {
    if (e.target.closest('.bls-v2__nav') || e.target.closest('.bls-v2__thumb')) {
      // next frame, after DOM updates
      requestAnimationFrame(syncThumbsHeight);
      setTimeout(syncThumbsHeight, 120);
    }
  });

  // Recalc when images load in the stage (first render or lazy-load)
  root.querySelectorAll('.bls-v2__stage-inner img').forEach(img => {
    if (img.complete) return;
    img.addEventListener('load', syncThumbsHeight, { once: true });
    img.addEventListener('error', syncThumbsHeight, { once: true });
  });

  // Kick it off
  requestAnimationFrame(syncThumbsHeight);
  setTimeout(syncThumbsHeight, 150);
})();

  // ---- Data
  let product = {};
  try { product = JSON.parse($('#ProductJsonV2')?.textContent || '{}'); } catch(e){}
    // Current currency ISO (Markets / localization)
  let CURRENCY_ISO = 'USD';
  try {
    const locEl = document.getElementById('BlsV2LocCurrency');
    if (locEl) {
      const loc = JSON.parse(locEl.textContent || '{}');
      if (loc && loc.iso) CURRENCY_ISO = loc.iso;
    }
  } catch (e) {
    // Fallbacks
    if (window.Shopify?.currency?.active) CURRENCY_ISO = window.Shopify.currency.active;
  }


  // ---- Asset & Metafield maps
  function getAssetMap() {
    try { return JSON.parse($('#FinishAssetMapV2')?.textContent || '{}'); } catch(e){ return {}; }
  }
  function getMetaMap() {
    try { return JSON.parse($('#FinishImageMapV2')?.textContent || '{}'); } catch(e){ return {}; }
  }
  const assetMap = getAssetMap();
  const metaMap  = getMetaMap();

  // ==== Height sync to finishing fieldset ====
  function findFinishingFieldset() {
    let fs = root.querySelector('.bls-v2__finish-fieldset');
    if (fs) return fs;
    const sets = $$('.bls-v2__option');
    fs = sets.find(s => /finish|color|colour/i.test(s.querySelector('legend')?.textContent || ''));
    return fs || root.querySelector('.bls-v2__info .bls-v2__options');
  }
  function px(n){ return `${Math.max(0, Math.round(n))}px`; }
  function computeOuterHeight(el){
    if (!el) return 0;
    const r = el.getBoundingClientRect();
    const cs = window.getComputedStyle(el);
    return r.height + (parseFloat(cs.marginTop)||0) + (parseFloat(cs.marginBottom)||0);
  }
  function syncPreviewHeight() {
    const fig = root.querySelector('.bls-v2__finish-figure');
    const img = root.querySelector('.bls-v2__finish-figure img');
    if (!fig) return;
    const fs = findFinishingFieldset();
    const h = Math.round(computeOuterHeight(fs) * 0.8);
    if (h > 0) {

      if (img) { img.style.height = '100%'; img.style.maxHeight = '100%'; }
    } else {
      fig.style.height = '';
      fig.style.minHeight = '';
      if (img) { img.style.height = ''; img.style.maxHeight = ''; }
    }
  }
  let _rh; function debouncedSync(){ clearTimeout(_rh); _rh = setTimeout(syncPreviewHeight, 80); }
  window.addEventListener('resize', debouncedSync);
  //const mo = new MutationObserver(debouncedSync);
  //mo.observe(root, { subtree: true, childList: true, attributes: true });

  // ---- Gallery
  const slides = $$('.bls-v2__slide');
  const thumbs = $$('.bls-v2__thumb');
  let activeIndex = 0;
    function firstSlideSrc(){
    const s0 = slides[0]?.querySelector('img')?.src;
    if (s0) return s0;
    const m0 = (product.media || [])[0]?.src || (product.images || [])[0];
    return m0 || '';
  }
  function showSlide(idx){
    if (!slides.length) return;
    idx = (idx + slides.length) % slides.length;
    slides.forEach(s => s.classList.remove('is-active'));
    thumbs.forEach(t => t.setAttribute('aria-selected','false'));
    slides[idx].classList.add('is-active');
    thumbs[idx]?.setAttribute('aria-selected','true');
    activeIndex = idx;
    const counter = root.querySelector('#BlsV2ImageCounter');
if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
  }
  thumbs.forEach(btn => btn.addEventListener('click', () => { showSlide(parseInt(btn.dataset.index,10)); debouncedSync(); }));
  root.addEventListener('click', e => {
    if (e.target.closest('[data-prev]')) { showSlide(activeIndex - 1); debouncedSync(); }
    if (e.target.closest('[data-next]')) { showSlide(activeIndex + 1); debouncedSync(); }
  });
  // Mobile finger swipe for main gallery - stronger version
(function setupMobileSwipe(){
  const stage = root.querySelector('.bls-v2__stage');
  if (!stage || !slides.length) return;

  let startX = 0;
  let startY = 0;
  let movedX = 0;
  let movedY = 0;
  let isTouching = false;
  let didSwipe = false;

  stage.addEventListener('touchstart', function(e){
    if (!window.matchMedia('(max-width: 991.98px)').matches) return;
    

    const t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    movedX = 0;
    movedY = 0;
    isTouching = true;
    didSwipe = false;
  }, { passive: true });

  stage.addEventListener('touchmove', function(e){
    if (!isTouching) return;

    const t = e.touches[0];
    movedX = t.clientX - startX;
    movedY = t.clientY - startY;

    // When horizontal swipe is clear, stop page/other handlers from taking it
    if (Math.abs(movedX) > Math.abs(movedY) && Math.abs(movedX) > 12) {
      e.preventDefault();
    }
  }, { passive: false });

  stage.addEventListener('touchend', function(e){
    if (!isTouching) return;
    isTouching = false;

    // Ignore vertical scroll
    if (Math.abs(movedY) > Math.abs(movedX)) return;

    // Minimum swipe distance
    if (Math.abs(movedX) < 40) return;

    didSwipe = true;

    if (movedX < 0) {
      showSlide(activeIndex + 1);
    } else {
      showSlide(activeIndex - 1);
    }

    debouncedSync();

    // Prevent accidental click/zoom after swipe
    setTimeout(function(){
      didSwipe = false;
    }, 250);
  }, { passive: true });

  stage.addEventListener('click', function(e){
    if (!didSwipe) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);
})();
  showSlide(0);
/*
// Lightweight click-to-zoom on main gallery image
(function setupSimpleStageZoom(){
  const stageInner = root.querySelector('.bls-v2__stage-inner');
  const activeImg = () => root.querySelector('.bls-v2__slide.is-active img');
  if (!stageInner) return;

  let zoomed = false;

  function clearZoom(){
    zoomed = false;
    stageInner.classList.remove('is-simple-zoomed');
    stageInner.style.removeProperty('--zoom-x');
    stageInner.style.removeProperty('--zoom-y');
  }

  stageInner.addEventListener('click', (e) => {
    if (e.target.closest('.bls-v2__nav')) return;
    if (e.target.closest('.bls-v2__share-btn')) return;

    zoomed = !zoomed;
    stageInner.classList.toggle('is-simple-zoomed', zoomed);

    if (!zoomed) {
      clearZoom();
    }
  });

  stageInner.addEventListener('mousemove', (e) => {
    if (!zoomed) return;
    const img = activeImg();
    if (!img) return;

    const r = stageInner.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;

    stageInner.style.setProperty('--zoom-x', `${Math.max(0, Math.min(100, x))}%`);
    stageInner.style.setProperty('--zoom-y', `${Math.max(0, Math.min(100, y))}%`);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') clearZoom();
  });

  root.addEventListener('click', (e) => {
    if (e.target.closest('.bls-v2__thumb') || e.target.closest('[data-prev]') || e.target.closest('[data-next]')) {
      clearZoom();
    }
  });
})();
*/
  // Zoom (overlay with thumbnail strip)
const overlay = document.createElement('div');
overlay.className = 'bls-v2__zoom-overlay';
overlay.innerHTML = `
  <button class="bls-v2__zoom-close" aria-label="Close">×</button>
  <img class="bls-v2__zoom-img" alt="Zoomed image">
  <div class="bls-v2__zoom-strip" role="listbox" aria-label="Images"></div>
`;
document.body.appendChild(overlay);

const zoomImg = overlay.querySelector('.bls-v2__zoom-img');
const strip   = overlay.querySelector('.bls-v2__zoom-strip');

// --- Click-to-zoom + drag-to-pan INSIDE the overlay ---
let isZoomed   = false;
let isDragging = false;
let dragMoved  = false;  // tracks whether pointer actually moved
let startX     = 0;
let startY     = 0;
let translateX = 0;
let translateY = 0;
const ZOOM_SCALE = 2.2; // adjust zoom strength here

zoomImg.style.transition = 'transform 0.15s ease-out';
zoomImg.style.cursor = 'zoom-in';

function applyZoomTransform() {
  if (!isZoomed) {
    zoomImg.style.transform = '';
    zoomImg.style.cursor = 'zoom-in';
    return;
  }
  zoomImg.style.transform = `translate(${translateX}px, ${translateY}px) scale(${ZOOM_SCALE})`;
  zoomImg.style.cursor = isDragging ? 'grabbing' : 'grab';
}
// Click / double-tap zoom inside overlay
let lastTapTime = 0;
let tapStartX = 0;
let tapStartY = 0;
let tapMoved = false;

// Prevent browser's own double-tap zoom from fighting our image zoom
zoomImg.style.touchAction = 'none';

function resetOverlayZoomState() {
  isZoomed = false;
  isDragging = false;
  dragMoved = false;
  translateX = 0;
  translateY = 0;
  applyZoomTransform();
}

function zoomInOverlayImage() {
  isZoomed = true;
  isDragging = false;
  dragMoved = false;
  translateX = 0;
  translateY = 0;
  applyZoomTransform();
}

function zoomOutOverlayImage() {
  resetOverlayZoomState();
}

function toggleOverlayZoom(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  if (isZoomed) {
    zoomOutOverlayImage();
  } else {
    zoomInOverlayImage();
  }

  lastTapTime = 0;
}

// Desktop click zoom
zoomImg.addEventListener('click', function(e) {
  if ('ontouchstart' in window) return;

  // If user dragged the zoomed image, do not treat mouseup as a zoom-out click
  if (dragMoved) {
    e.preventDefault();
    e.stopPropagation();
    dragMoved = false;
    return;
  }

  toggleOverlayZoom(e);
});

// Track mobile tap movement
zoomImg.addEventListener('touchstart', function(e) {
  if (!e.touches || !e.touches[0]) return;

  tapStartX = e.touches[0].clientX;
  tapStartY = e.touches[0].clientY;
  tapMoved = false;
}, { passive: true });

zoomImg.addEventListener('touchmove', function(e) {
  if (!e.touches || !e.touches[0]) return;

  const dx = e.touches[0].clientX - tapStartX;
  const dy = e.touches[0].clientY - tapStartY;

  if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
    tapMoved = true;
  }
}, { passive: true });

// Mobile double-tap zoom in / zoom out
zoomImg.addEventListener('touchend', function(e) {
  // If user dragged/panned the zoomed image, do NOT treat it as a tap
  if (tapMoved || dragMoved || isDragging) {
    lastTapTime = 0;
    tapMoved = false;
    dragMoved = false;
    return;
  }

  const now = Date.now();
  const timeSinceLastTap = now - lastTapTime;

  if (timeSinceLastTap > 0 && timeSinceLastTap < 400) {
    toggleOverlayZoom(e);
    lastTapTime = 0;
  } else {
    lastTapTime = now;
  }
}, { passive: false });
// Helpers for mouse/touch points
function getPoint(e) {
  if (e.touches && e.touches[0]) {
    return { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }
  return { x: e.clientX, y: e.clientY };
}

// Start drag
function onDragStart(e) {
  if (!isZoomed) return;
  e.preventDefault();
  e.stopPropagation();

  const p = getPoint(e);
  isDragging = true;
  dragMoved  = false;  // reset at drag start
  startX = p.x;
  startY = p.y;

  applyZoomTransform();
}

// Move drag
function onDragMove(e) {
  if (!isDragging) return;

  const p = getPoint(e);
  const dx = p.x - startX;
  const dy = p.y - startY;

  // mark that pointer actually moved
  if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
    dragMoved = true;
  }

  startX = p.x;
  startY = p.y;

  translateX += dx;
  translateY += dy;

  applyZoomTransform();
}

// End drag
function onDragEnd() {
  if (!isDragging) return;
  isDragging = false;
  applyZoomTransform();
}

// Mouse events
zoomImg.addEventListener('mousedown', onDragStart);
window.addEventListener('mousemove', onDragMove);
window.addEventListener('mouseup', onDragEnd);

// Touch events
zoomImg.addEventListener('touchstart', onDragStart, { passive: false });
window.addEventListener('touchmove', onDragMove, { passive: false });
window.addEventListener('touchend', onDragEnd);
window.addEventListener('touchcancel', onDragEnd);

// Build the overlay strip from the existing gallery thumbnails
thumbs.forEach((btn, i) => {
  const thumbImg = btn.querySelector('img');
  if (!thumbImg) return;
  const srcThumb = thumbImg.currentSrc || thumbImg.src || '';
  const srcFull  = srcThumb.includes('width=')
    ? srcThumb.replace(/width=\d+/, 'width=2000')
    : srcThumb;

  const t = document.createElement('button');
  t.type = 'button';
  t.className = 'bls-v2__zoom-thumb';
  t.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
  t.innerHTML = `<img src="${srcThumb}" alt="Image ${i+1}">`;
t.addEventListener('click', () => {
  isZoomed = false;
  isDragging = false;
  dragMoved = false;
  translateX = 0;
  translateY = 0;
  applyZoomTransform();

  zoomImg.src = srcFull;

  strip.querySelectorAll('.bls-v2__zoom-thumb')
       .forEach(x => x.setAttribute('aria-selected','false'));
  t.setAttribute('aria-selected','true');

  showSlide(i);
});
  strip.appendChild(t);
});

overlay.addEventListener('click', (e) => {
  if (e.target === overlay || e.target.classList.contains('bls-v2__zoom-close')) {
    overlay.classList.remove('is-open');
    // reset zoom state
    isZoomed   = false;
    isDragging = false;
    dragMoved  = false;
    translateX = 0;
    translateY = 0;
    applyZoomTransform();
  }
});
// Swipe left/right inside zoom overlay to change image
(function setupZoomOverlaySwipe(){
  let zoomStartX = 0;
  let zoomStartY = 0;
  let zoomMoveX = 0;
  let zoomMoveY = 0;
  let zoomTouching = false;

  function resetZoomState() {
    isZoomed = false;
    isDragging = false;
    dragMoved = false;
    translateX = 0;
    translateY = 0;
    applyZoomTransform();
  }

  function openZoomImageByIndex(i) {
    const btn = thumbs[i];
    if (!btn) return;

    const thumbImg = btn.querySelector('img');
    if (!thumbImg) return;

    const srcThumb = thumbImg.currentSrc || thumbImg.src || '';
    const srcFull = srcThumb.includes('width=')
      ? srcThumb.replace(/width=\d+/, 'width=2000')
      : srcThumb;

    resetZoomState();

    zoomImg.src = srcFull;
    showSlide(i);

    strip.querySelectorAll('.bls-v2__zoom-thumb')
      .forEach((x, idx) => x.setAttribute('aria-selected', idx === i ? 'true' : 'false'));
  }

  overlay.addEventListener('touchstart', function(e){
    if (!overlay.classList.contains('is-open')) return;

    // If image is already zoomed in, allow drag-to-pan instead of changing image
    if (isZoomed) return;

    const t = e.touches[0];
    zoomStartX = t.clientX;
    zoomStartY = t.clientY;
    zoomMoveX = 0;
    zoomMoveY = 0;
    zoomTouching = true;
  }, { passive: true });

  overlay.addEventListener('touchmove', function(e){
    if (!zoomTouching) return;

    const t = e.touches[0];
    zoomMoveX = t.clientX - zoomStartX;
    zoomMoveY = t.clientY - zoomStartY;

    if (Math.abs(zoomMoveX) > Math.abs(zoomMoveY) && Math.abs(zoomMoveX) > 12) {
      e.preventDefault();
    }
  }, { passive: false });

  overlay.addEventListener('touchend', function(){
    if (!zoomTouching) return;
    zoomTouching = false;

    if (Math.abs(zoomMoveY) > Math.abs(zoomMoveX)) return;
    if (Math.abs(zoomMoveX) < 45) return;

    if (zoomMoveX < 0) {
      openZoomImageByIndex(activeIndex + 1);
    } else {
      openZoomImageByIndex(activeIndex - 1);
    }
  }, { passive: true });
})();

// --- CAPTURE-PHASE SHARE HANDLER: perform share, then stop zoom from seeing the click
document.addEventListener('click', async function (e) {
  const btn = e.target && e.target.closest('.bls-v2__share-btn');
  if (!btn) return;

  // run share *in capture*, so iOS/Android treat it as a user gesture
  const url   = btn.getAttribute('data-share-url')   || location.href;
  const title = btn.getAttribute('data-share-title') || document.title;

  try {
    if (navigator.share) {
      await navigator.share({ title, url });
    } else if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      // tiny visual feedback
      const prev = btn.title || 'Share';
      btn.title = 'Link copied!';
      btn.setAttribute('aria-label', 'Link copied!');
      setTimeout(() => { btn.title = prev; btn.setAttribute('aria-label', 'Share this product'); }, 1200);
    } else {
      alert('Share this link:\n' + url);
    }
  } catch {
    // user canceled native share — ignore
  } finally {
    // prevent ANY zoom/openers (capture or bubble) from seeing this click
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true); // capture

root.addEventListener('click', (e) => {
    const si = e.target.closest('.bls-v2__stage-inner');
  if (!si || e.target.closest('.bls-v2__nav')) return; // ignore prev/next buttons
  if (e.target.closest('.bls-v2__share-btn')) return;
  const img = si.querySelector('img'); if (!img) return;

  // Always reset zoom before opening overlay
  resetOverlayZoomState();

  const raw = img.currentSrc || img.src;
  zoomImg.src = raw.includes('width=')
    ? raw.replace(/width=\d+/, 'width=2000')
    : raw;

  // reflect current active slide in the strip
  strip.querySelectorAll('.bls-v2__zoom-thumb')
       .forEach((b, idx) => b.setAttribute('aria-selected', idx === activeIndex ? 'true' : 'false'));

  overlay.classList.add('is-open');
}, true);
// Share button on the main image
root.addEventListener('click', async (e) => {
  const btn = e.target.closest('.bls-v2__share-btn');
  if (!btn) return;

  try {
    const url   = location.href;
    const title = document.querySelector('#bls-product-v2 .bls-v2__title')?.textContent?.trim() || document.title;

    if (navigator.share) {
      await navigator.share({ title, url });
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(url);
      // quick inline feedback
      const old = btn.title;
      btn.title = 'Link copied!';
      btn.setAttribute('aria-label', 'Link copied!');
      setTimeout(() => { btn.title = old || 'Share'; btn.setAttribute('aria-label','Share this product'); }, 1400);
    } else {
      // ultimate fallback
      alert('Link: ' + url);
    }
  } catch (err) {
    // user may cancel the native share — that’s fine; do nothing
    console.warn('Share action cancelled or failed', err);
  }
}, true);

// Close on ESC
window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') overlay.classList.remove('is-open');
});

  // ---- Variant, price/stock/headline
  const priceEl   = $('#BlsV2Price');
  const compareEl = $('#BlsV2Compare');
  const stockLi   = $('#BlsV2Stock')?.closest('li');
  const stockEl   = $('#BlsV2Stock');
  const etaEl     = $('#BlsV2Eta');
  const variantMain = $('#ProductVariantIdV2');
  const variantBox  = $('#ProductVariantIdV2Box');

  const hlNow = document.getElementById('headline-now');
  const hlWas = document.getElementById('headline-was');
  const hlOff = document.getElementById('headline-off');

    function formatMoney(cents){
    const amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY_ISO }).format(amount);
    } catch(e) {
      return `${CURRENCY_ISO} ${amount.toFixed(2)}`; // fallback
    }
  }

  function selectedVariant(){
    if (!product?.variants?.length) return null;
    return product.variants.find(v => String(v.id) === String(variantMain?.value))
      || product.variants[0];
  }

  function updateHeadline(v){
    if (!v || !hlNow) return;
    hlNow.textContent = formatMoney(v.price);
    if (hlWas && hlOff){
      if (v.compare_at_price && v.compare_at_price > v.price){
        const pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        hlWas.style.display = '';
        hlOff.style.display = '';
        hlWas.textContent = formatMoney(v.compare_at_price);
        hlOff.textContent = `${pct}% off`;
      } else {
        hlWas.style.display = 'none';
        hlOff.style.display = 'none';
      }
    }
  }

  function updatePriceStock(v){
    if (!v) return;
    if (variantMain) variantMain.value = v.id;
    if (variantBox)  variantBox.value  = v.id;

    if (priceEl) priceEl.textContent = formatMoney(v.price);
    if (compareEl){
      if (v.compare_at_price && v.compare_at_price > v.price){
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
        // Discount badge in purchase box (next to price)
    const boxOff = document.getElementById('BlsV2BoxOff');
    if (boxOff) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        boxOff.textContent = `${pct}% off`;
        boxOff.style.display = '';
      } else {
        boxOff.style.display = 'none';
      }
    }

    if (stockLi && stockEl){
      if (v.inventory_management){
        stockLi.style.display = '';
        stockEl.textContent = v.inventory_quantity ?? '';
      } else {
        stockLi.style.display = 'none';
      }
    }
    updateHeadline(v);
  }

  function updateEta(){
    const aside = $('.bls-v2__purchase');
    const days = parseInt(aside?.dataset.etaDays || '12', 10);
    const d = new Date(); d.setDate(d.getDate() + days);
    etaEl && (etaEl.textContent = d.toLocaleDateString(undefined,{month:'short',day:'numeric',year:'numeric'}));
  }

  // ---- Finish preview logic
  const finishImg = $('#BlsV2FinishImg');
  const finishCap = $('#BlsV2FinishCap');

  (function setupPreviewZoom(){
    const fig = root.querySelector('.bls-v2__finish-figure');
    if (!fig || !finishImg) return;

    let zooming = false;
    let scale = 1.3;

    function startZoom(){
      if (!finishImg.src) return;
      zooming = true;
      fig.classList.add('is-zooming');
      fig.style.backgroundImage = `url(${finishImg.src})`;
      fig.style.backgroundSize  = `${Math.round(scale*100)}% auto`;
    }
    function stopZoom(){
      zooming = false;
      fig.classList.remove('is-zooming');
      fig.style.backgroundImage = '';
      fig.style.backgroundPosition = '';
    }
    function moveZoom(e){
      if (!zooming) return;
      const rect = fig.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const x = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      const y = Math.max(0, Math.min(1, (clientY - rect.top)  / rect.height));
      fig.style.backgroundPosition = `${(x*100).toFixed(1)}% ${(y*100).toFixed(1)}%`;
    }

    fig.addEventListener('mouseenter', startZoom);
    fig.addEventListener('mousemove',  moveZoom);
    fig.addEventListener('mouseleave', stopZoom);
    fig.addEventListener('touchstart', (e)=>{ startZoom(); moveZoom(e); }, {passive:true});
    fig.addEventListener('touchmove',  moveZoom, {passive:true});
    fig.addEventListener('touchend',   stopZoom);

    //const obs = new MutationObserver(()=>{ if (zooming) { stopZoom(); startZoom(); } });
    //obs.observe(finishImg, { attributes:true, attributeFilter:['src'] });
  })();


  function normalize(s){ return (s||'').toString().toLowerCase().trim(); }

// Finish preview should stay empty until customer manually chooses a finish
let blsFinishUserSelected = false;

function setFinishPreview(url, label){
  if (!blsFinishUserSelected) return;

  const finishFigure = root.querySelector('.bls-v2__finish-figure');

  if (finishFigure) {
    finishFigure.classList.remove('is-empty');
    finishFigure.classList.remove('is-zooming');
    finishFigure.style.backgroundImage = '';
    finishFigure.style.backgroundPosition = '';
  }

  if (finishImg && url){
    finishImg.style.display = 'block';
    finishImg.style.opacity = '0';

    const img = new Image();

    img.onload = () => {
      if (!blsFinishUserSelected) return;

      finishImg.src = url;
      finishImg.alt = (label || 'Selected finish') + ' finish preview';

      requestAnimationFrame(() => {
        finishImg.style.opacity = '1';
      });
    };

    img.src = url;
  }

  if (finishCap) {
    finishCap.innerHTML = `
      <strong>Finish Preview Only</strong><br>
      <span>${label || ''} — color reference, not the product photo.</span>
    `;
  }
}



  function setPreviewFromCandidates(candidates, label, fallbackFn){
    if (!finishImg || !candidates || !candidates.length){
      if (fallbackFn) fallbackFn();
      return;
    }
    let i = 0;
    const tryNext = () => {
      if (i >= candidates.length){
        if (fallbackFn) fallbackFn();
        return;
      }
      const url = candidates[i++];
      const test = new Image();
      test.onload = () => setFinishPreview(url, label);
      test.onerror = tryNext;
      test.src = url;
    };
    tryNext();
  }

  function candidateUrlsFromAsset(asset){
    if (!asset) return [];
    if (/\.(jpg|jpeg|png|webp)$/i.test(asset)) {
      const base = asset.replace(/\.(jpg|jpeg|png|webp)$/i, '');
      return [asset, base + '.jpg', base + '.jpeg', base + '.png', base + '.webp'];
    }
    return [asset, asset + '.jpg', asset + '.jpeg', asset + '.png', asset + '.webp'];
  }

  function updateFinishPreview(value, assetOverride){
    if (!finishImg) return;

    const label = value || '';
    const nv = normalize(value);

    if (nv === 'as shown in the image' || nv === 'as shown' || nv === 'as seen in image') {
      const src = firstSlideSrc();
      if (src) {
        setFinishPreview(src, label);
        return;
      }
    }

    if (assetOverride) {
      const list = candidateUrlsFromAsset(assetOverride);
      setPreviewFromCandidates(list, label, () => updateFinishPreview(value));
      return;
    }

    const assetUrl = assetMap[value] || assetMap[Object.keys(assetMap).find(k => normalize(k) === nv)];
    if (assetUrl) {
      setPreviewFromCandidates(candidateUrlsFromAsset(assetUrl), label, () => {
        const src = firstSlideSrc();
        if (src) setFinishPreview(src, label);
      });
      return;
    }

    const mapped = metaMap[value] || metaMap[Object.keys(metaMap).find(k => normalize(k) === nv)];
    if (typeof mapped === 'number') {
      const s = $$('.bls-v2__slide')[mapped];
      const src = s?.querySelector('img')?.src;
      if (src) {
        setFinishPreview(src, label);
        return;
      }
    } else if (typeof mapped === 'string') {
      const idx = (product.media||[]).findIndex(mm => normalize(mm.alt).includes(normalize(mapped)));
      if (idx >= 0) {
        const s = $$('.bls-v2__slide')[idx];
        const src = s?.querySelector('img')?.src;
        if (src) {
          setFinishPreview(src, label);
          return;
        }
      }
    }

    const idx = (product.media||[]).findIndex(mm => normalize(mm.alt).includes(nv));
    if (idx >= 0) {
      const s = $$('.bls-v2__slide')[idx];
      const src = s?.querySelector('img')?.src;
      if (src) {
        setFinishPreview(src, label);
        return;
      }
    }

    const fallbackSrc = firstSlideSrc();
    if (fallbackSrc) setFinishPreview(fallbackSrc, label);
  }

  function applyFinishFromInput(inp){
    if (!inp) return;
    const value = inp.value || '';
    const asset = inp.getAttribute('data-finish-asset') || '';
    const finProp = document.getElementById('BlsV2FinishProperty');
    if (finProp) finProp.value = value;
    updateFinishPreview(value, asset);
    debouncedSync();
  }

  const finishInputs = $$('.bls-v2__options input[type="radio"]').filter(inp => {
    const optionName = (inp.getAttribute('data-option-name') || '').toLowerCase();
    return inp.name === 'custom_finish_picker' || /finish|color|colour/.test(optionName) || inp.hasAttribute('data-finish-asset');
  });

let blsFinishManualIntent = false;

finishInputs.forEach(inp => {
  const clickableSwatch = inp.closest('.bls-v2__swatch') || inp.closest('label') || inp.parentElement;

  if (clickableSwatch) {
    clickableSwatch.addEventListener('pointerdown', () => {
      blsFinishManualIntent = true;
    });

    clickableSwatch.addEventListener('click', () => {
      blsFinishManualIntent = true;
    });
  }

  inp.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      blsFinishManualIntent = true;
    }
  });

  inp.addEventListener('change', () => {
    blsFinishUserSelected = true;
    blsFinishManualIntent = false;

    const v = selectedVariant();
    updatePriceStock(v);

    const finishFigure = root.querySelector('.bls-v2__finish-figure');
    if (finishFigure) {
      finishFigure.classList.remove('is-empty');
      finishFigure.classList.remove('is-zooming');
      finishFigure.style.backgroundImage = '';
      finishFigure.style.backgroundPosition = '';
    }

    if (finishImg) {
      finishImg.style.display = 'block';
      finishImg.style.opacity = '0';
    }

    applyFinishFromInput(inp);
  });
});

// Qty +/- controls

// Qty +/- controls
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-inc],[data-qty-dec]');
    if (!btn) return;
    e.preventDefault();
    const field = $('#BlsV2Qty');
    if (!field) return;
    let n = parseInt(field.value||'1',10);
    n += btn.hasAttribute('data-qty-inc') ? 1 : -1;
    field.value = Math.max(1,n);
  });

  // Prevent duplicate submits
  const purchaseForm = document.getElementById('ProductFormV2Box');
  if (purchaseForm) {
    let isSubmitting = false;
    purchaseForm.addEventListener('submit', function(e) {
      if (isSubmitting) {
        e.preventDefault();
        return false;
      }
      isSubmitting = true;
      const btn = purchaseForm.querySelector('.bls-v2__add');
      if (btn) {
        btn.disabled = true;
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Adding...';
      }
      setTimeout(function(){
        isSubmitting = false;
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.originalText || 'Add to cart';
        }
      }, 2000);
    }, true);
  }

  const tablist = root.querySelector('.bls-v2__tablist');
if (tablist){
  const tabsRoot = root.querySelector('.bls-v2__tabs-inner') || root;
  const buttons  = Array.from(tablist.querySelectorAll('button[role="tab"]'));
  const panels   = Array.from(tabsRoot.querySelectorAll('section[role="tabpanel"]'));

  function showById(id){
    // toggle buttons
    buttons.forEach(b => {
      const on = b.getAttribute('aria-controls') === id;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    // toggle panels
    panels.forEach(p => { p.hidden = (p.id !== id); });
  }

  tablist.addEventListener('click', (e) => {
    const btn = e.target.closest('button[role="tab"]');
    if (!btn) return;
    const id = btn.getAttribute('aria-controls');
    if (!id) return;
    showById(id);
    if (typeof debouncedSync === 'function') debouncedSync();
  });

  // initial: use the one marked aria-selected="true", else first
  const initial = buttons.find(b => b.getAttribute('aria-selected') === 'true') || buttons[0];
  if (initial) showById(initial.getAttribute('aria-controls'));
}


  // Init
  updateEta();
  const v0 = selectedVariant();
  updatePriceStock(v0);

// Do NOT pre-select or preview any finish on page load
const finPropInit = document.getElementById('BlsV2FinishProperty');

function clearFinishPreviewOnLoad() {
  blsFinishUserSelected = false;

  finishInputs.forEach(inp => {
    inp.checked = false;
    inp.defaultChecked = false;
    inp.removeAttribute('checked');

    const wrap = inp.closest('.bls-v2__swatch');
    if (wrap) wrap.classList.remove('is-selected', 'active', 'selected');
  });

  if (finPropInit) finPropInit.value = '';

  if (finishImg) {
    finishImg.removeAttribute('src');
    finishImg.removeAttribute('alt');
    finishImg.style.display = 'none';
    finishImg.style.opacity = '0';
  }

if (finishCap) {
  finishCap.textContent = '';
}

  const finishFigure = root.querySelector('.bls-v2__finish-figure');
  if (finishFigure) {
    finishFigure.classList.add('is-empty');
    finishFigure.classList.remove('is-zooming');
    finishFigure.style.backgroundImage = '';
    finishFigure.style.backgroundPosition = '';
  }
}

clearFinishPreviewOnLoad();

window.addEventListener('pageshow', clearFinishPreviewOnLoad);
document.addEventListener('shopify:section:load', clearFinishPreviewOnLoad);

  requestAnimationFrame(() => { syncPreviewHeight(); setTimeout(syncPreviewHeight, 120); });
})();

// Align the right preview to the top of swatch tags/first swatch tile
function syncPreviewTopStandalone() {
  const root = document.getElementById('bls-product-v2') || document;
  const previewWrap = root.querySelector('.bls-v2__finish-image');
  if (!previewWrap) return;

  previewWrap.style.setProperty('--bls-finish-tags-offset', '0px');
  previewWrap.style.marginTop = '0px';
}

window.addEventListener('load', syncPreviewTopStandalone);
window.addEventListener('resize', syncPreviewTopStandalone);
document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('bls-product-v2');
  if (!root) return;

  const desc = root.querySelector('[data-bls-description-content]');
  const btn = root.querySelector('[data-bls-description-toggle]');

  if (!desc || !btn) return;

  btn.addEventListener('click', function () {
    desc.classList.toggle('is-expanded');

    btn.textContent = desc.classList.contains('is-expanded')
      ? 'Show Less'
      : 'Show More';
  });
});

(function setupStickyMobileATC(){
  const sticky = document.getElementById('bls-sticky-atc');
  const mainBtn = document.querySelector('#ProductFormV2Box .bls-v2__add');
  const finishText = document.getElementById('BlsStickyFinish');

  if (!sticky || !mainBtn) return;

  function isMobile(){
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  function updateFinish(){
    const checked = document.querySelector('#bls-product-v2 input[name="custom_finish_picker"]:checked');
    if (finishText && checked) {
      finishText.textContent = checked.dataset.finishValue || checked.value || 'Selected finish';
    }
  }

  function updateSticky(){
    if (!isMobile()) {
      sticky.hidden = true;
      return;
    }

    const rect = mainBtn.getBoundingClientRect();

    if (rect.bottom < 0) {
      sticky.hidden = false;
      updateFinish();
    } else {
      sticky.hidden = true;
    }
  }

  document.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);

  document.querySelectorAll('#bls-product-v2 input[name="custom_finish_picker"]').forEach(input => {
    input.addEventListener('change', function(){
      updateFinish();
      updateSticky();
    });
  });

  updateFinish();
  updateSticky();
})();